import { Sparkles, X } from 'lucide-react';
import { cn } from '@/utils/cn';
import type { AIDraftState } from './types';
import { MODE_LABELS } from './types';
import type { CopilotMode } from './types';

interface Props {
  draft: AIDraftState;
  onClear: () => void;
}

export function ComposerAIBadge({ draft, onClear }: Props) {
  if (draft.kind === 'none') return null;

  const isEdited = draft.kind === 'ai_edited';
  const modeLabel = draft.mode ? (MODE_LABELS[draft.mode as CopilotMode] ?? draft.mode) : null;

  return (
    <div className={cn(
      'flex items-center justify-between px-3 py-2 rounded-t-xl border-b',
      'text-xs transition-colors',
      isEdited
        ? 'bg-amber-50 border-amber-200 text-amber-700'
        : 'bg-violet-50 border-violet-200 text-violet-700'
    )}>
      <div className="flex items-center gap-1.5">
        <Sparkles className="w-3.5 h-3.5 flex-shrink-0" />
        <span className="font-medium">
          {isEdited ? 'AI-черновик (изменён)' : 'AI-черновик'}
          {modeLabel ? ` · ${modeLabel}` : ''}
        </span>
      </div>
      <button
        onClick={onClear}
        title="Отвязать от AI (текст останется)"
        className="p-0.5 rounded hover:bg-black/10 transition-colors flex-shrink-0"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
